<div class="chips-and-input-container">
  <mat-chip-listbox *ngIf="value?.length">
    <mat-chip-option
      *ngFor="let selectedOption of value"
      class="mb-3"
      [removable]="true"
      (removed)="onSelectedOptionRemoved(selectedOption)">
      <span class="inline-block truncate max-w-56" [ellipsisTooltip]="displayFn(selectedOption)">{{displayFn(selectedOption)}}</span>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip-option>
  </mat-chip-listbox>

  <input
    type="search"
    [placeholder]="placeholder"
    [required]="isOneChipNeeded"
    matInput
    [formControl]="inputControl"
    [matAutocomplete]="auto"
    (focusin)="onFocusIn($event)"
    (focusout)="onFocusOut($event)"
    (keydown.enter)="onInputEnter($event)" />
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
    <mat-option
      *ngFor="let option of filteredOptions | async"
      [value]="option"
      [disabled]="isOptionSelected(option)"
      (mousedown)="$event.preventDefault()">
      {{displayFn(option)}}
    </mat-option>
  </mat-autocomplete>
</div>
